import React from 'react'
import TermsHeader from '../components/Common/TermsHeader'

const TermsAndConditions = () => {
  return (
    <TermsHeader />
  )
}

export default TermsAndConditions